import React from 'react';
import { BaseModal } from '../comun/Index';
import Pase from '../mesa/Pase';

export default class ModalPase extends React.Component{
  constructor(props){
    super(props);
    this.state = {}
  }

  render(){
    const {areas, datosPase, editar, guardar, salir, nuevo} = this.props;
    return(
    <BaseModal
      titulo=""
      loading={false}
      botonera={[
        {titulo:"Salir", backgroundColor:'#FF2C00', onClick: () => salir()},
        {titulo:"Guardar", backgroundColor:'#00B845', onClick: () => guardar()}
      ]}
    >
      <Pase
        nuevo={nuevo}
        areas={areas}
        datos={datosPase}
        editar={(campo, valor) => editar(campo, valor)}
      />
    </BaseModal>
    )
  }
}